import { configWebAttribution } from '@kma-core/client-web-attribution';
import { ampli } from './ampli';
import { PROJECT_NAME } from 'constants/env';

export const { webAttribution, loadAmpli } = configWebAttribution({
    ampli,
    environment: 'default',
    projectName: PROJECT_NAME,
    disableSessionReplayTracking: true,
});
